export default function headerSearchTrigger() {
    const body = document.querySelector('body');
    const header = document.querySelector('#header-buttons');
    const searchTrigger = header.querySelector('[data-script="search-trigger"]');
    const burger = header.querySelector('.header-buttons__burger-button');
    const menuWrap = header.querySelector('.js-menu-burger-opener-wrap');
    const menuBurger = document.querySelector('.js-menu-burger');
    const directions = header.querySelector('.header-buttons-internal__text');
    const search = document.querySelector('#search');
    const searchCloseBtn = search.querySelector('.search__close');
    const searchField = search.querySelector('#search-field');
    const windowLocation = window.location.href;

    function showSearch() {
        event.preventDefault(); // eslint-disable-line
        if (menuBurger.classList.contains('open')) {
            menuBurger.classList.remove('open');
            menuWrap.classList.remove('open');
        }
        body.classList.add('page-fix');
        const windowHeight = window.innerHeight;
        const headerHeight = header.offsetHeight;
        search.style.top = `${headerHeight}px`;
        search.style.height = `${windowHeight - headerHeight}px`;
        search.classList.add('active');
        searchTrigger.classList.add('active');
        searchField.focus();
        searchCloseBtn.addEventListener('click', () => hideSearch(), { once: true }); // eslint-disable-line
        searchTrigger.addEventListener('click', () => hideSearch(), { once: true }); // eslint-disable-line
        burger.addEventListener('click', () => hideSearch(true), { once: true }); // eslint-disable-line
        directions.addEventListener('click', () => hideSearch(true), { once: true }); // eslint-disable-line
        history.pushState(null, null, window.location.protocol + '//' + window.location.hostname + '/search/');  // eslint-disable-line
    }

    function hideSearch(popup) {
        event.preventDefault(); // eslint-disable-line
        if (!popup) {
            body.classList.remove('page-fix');
        }
        search.style.height = 0;
        search.classList.remove('active');

        searchTrigger.classList.remove('active');
        searchTrigger.addEventListener('click', () => showSearch(), { once: true });

        searchCloseBtn.removeEventListener('click', hideSearch); // eslint-disable-line
        searchTrigger.removeEventListener('click', hideSearch); // eslint-disable-line
        burger.removeEventListener('click', hideSearch); // eslint-disable-line
        directions.removeEventListener('click', hideSearch); // eslint-disable-line

        history.pushState(null, null, windowLocation);  // eslint-disable-line
    }

    searchTrigger.addEventListener('click', () => showSearch(), { once: true });
}
